import { ShiftOffersUndoReducerState } from './types';

export const getDefaultState = (): ShiftOffersUndoReducerState => ({
  deleteQueue: [],
  declineProposalQueue: [],
  approveProposalQueue: []
});
